import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import Button from "../shared/button/Button";
import qualificationTechniquesType from "./types/qualificationTechniquesType";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  Paragraph,
  Technique,
  TechniqueText,
  CloseButton,
  ButtonsWrapper,
} from "./styles/candidate-qualification-modal-styles";

export const CandidateQualificationModal = ({
  qualificationTechniques,
  toggleQualificationModal,
}) => (
  <Backdrop className="animated fadeIn">
    <ModalWrapper className="animated delay-1 fadeInDown">
      <Title>
        <TitleText>Candidate Qualification</TitleText>
        <CloseButton onClick={() => toggleQualificationModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Body>
        <Paragraph>
          I qualify my candidates using the following techniques:
        </Paragraph>
        {qualificationTechniques.map((technique) => (
          <Technique key={technique ? technique.replace(" ", "-") : ""}>
            <FontAwesomeIcon icon={faCheck} />
            <TechniqueText>{technique}</TechniqueText>
          </Technique>
        ))}
      </Body>
      <ButtonsWrapper>
        <Button
          primary
          buttonName="Close"
          onClickAction={() => toggleQualificationModal()}
        />
      </ButtonsWrapper>
    </ModalWrapper>
  </Backdrop>
);

CandidateQualificationModal.propTypes = {
  qualificationTechniques: qualificationTechniquesType.isRequired,
  toggleQualificationModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  qualificationTechniques:
    state.agencyProfile.profileData.qualificationTechniques,
});

export default connect(mapStateToProps, {})(CandidateQualificationModal);
